// imports section Start
import React, { useState, useEffect, useContext } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  externalgetApi,
  externalpostApi,
} from "../../../../services/external/externalApis";
import { ORDER_API_10 } from "../../../../api/ApiModel";
import { CON_STATUS_NEW } from "../../../../utils/sys/Constants";
import { styled, useTheme } from "@mui/material/styles";
import { useStyles } from "../../../../assets/styles/Theme";
import DeleteIcon from "@mui/icons-material/Delete";
import {
  Box,
  Grid,
  Typography,
  Paper,
  Button,
  IconButton,
  Stack,
  TextField,
  Card,
  CardContent,
} from "@mui/material";
import { addVoucher, removeVoucher } from "../../../../store/ReduxVoucherSlice";
import {
  MSG_VOUCHER_ENTER,
  MSG_VOUCHER_FAILED,
  MSG_VOUCHER_NO_MATCH,
  MSG_VOUCHER_NOT_AVAILABLE,
  MSG_VOUCHER_SUCCESS,
} from "../../../../utils/sys/Messages";
import SnackbarMessage from "../../../common/SnackbarMessage";
// imports section End

const Item = styled(Paper)(({ theme }) => ({
  width: "100%",
  padding: "4px",
}));

export default function CashierVoucherMobile({ setVoucherData }) {
  // Hooks start
  const theme = useTheme();
  const styles = useStyles(theme);
  const [value, setValue] = React.useState("one");

  const dispatch = useDispatch();
  const vouchers = useSelector((state) => state.vouchers.voucherList);
  const [snackbarOpen, setSnackbarOpen] = useState(false); // Control Snackbar visibility
  const [snackbarMessage, setSnackbarMessage] = useState(""); // Snackbar message
  const [snackbarSeverity, setSnackbarSeverity] = useState("success");

  const [voucherCode, setVoucherCode] = useState("");
  // const [vouchers, setVouchers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  // Hooks end

  // Get user parameters from Redux store
  const SYS_USER = useSelector((state) => state.user) || {};
  const { COMPCODE, LOCCODE } = SYS_USER.USER_PARAM || {};

  // Handlers start
  const currentDate = new Date().toISOString().split("T")[0];
  // Handle input change
  const handleVoucherCodeChange = (e) => {
    setVoucherCode(e.target.value);
  };
  const handleCloseSnackbar = () => {
    setSnackbarOpen(false);
  };
  // Function to remove voucher
  const removeVoucherHandler = (voucherCodeToRemove) => {
    dispatch(removeVoucher(voucherCodeToRemove)); // Remove voucher from Redux
    setVoucherData(null); // Clear the formData in parent component
  };

  const formatPrice = (price) => {
    return new Intl.NumberFormat("en-US", {
      // style: "currency",
      // currency: "LKR",
    }).format(price);
  };
  // Handlers end

  // API calls start
  // Function to add and validate voucher
  const addVoucherHandler = async () => {
    if (!voucherCode) {
      setSnackbarMessage(MSG_VOUCHER_ENTER);
      setSnackbarSeverity("error");
      setSnackbarOpen(true);
      return;
    }

    try {
      setLoading(true);
      setError(null);

      // Set up API parameters
      const params = {
        COMPCODE,
        LOCCODE,
        SEARCHKEY: voucherCode,
        STSN: CON_STATUS_NEW,
        SYSDATE: currentDate,
      };

      // Make GET request to fetch vouchers
      const response = await externalgetApi(ORDER_API_10, "GET", params);
      console.log("responseresponseresponse voucher code", response);
      // Check if any vouchers are available
      if (response?.length > 0) {
        // Find the matching voucher by either BARCODE or VOUCHERNO
        const matchingVoucher = response.find(
          (v) => v.BARCODE === voucherCode || v.VOUCHERNO === voucherCode
        );

        if (matchingVoucher) {
          const voucherData = {
            voucherrefcode: matchingVoucher.CERTIFICATECODE,
            vouchercode: matchingVoucher.GIFTVOUCHERCODE,
            voucherno: matchingVoucher.VOUCHERNO,
            voucherbarcode: matchingVoucher.BARCODE,
            voucheramount: matchingVoucher.AMOUNT,
          };
          dispatch(addVoucher(voucherData));
          setVoucherData(voucherData); // Update formData in parent component
          setVoucherCode("");

          setSnackbarMessage(MSG_VOUCHER_SUCCESS);
          setSnackbarSeverity("success");
          setSnackbarOpen(true);
        } else if (error) {
          // alert("No voucher matches the entered code.");
          setSnackbarMessage(MSG_VOUCHER_NO_MATCH);
          setSnackbarSeverity("error");
          setSnackbarOpen(true);
        }
      } else {
        // alert("No vouchers available for the entered code.");

        setSnackbarMessage(MSG_VOUCHER_NOT_AVAILABLE);
        setSnackbarSeverity("error");
        setSnackbarOpen(true);
      }
    } catch (error) {
      setError("Failed to validate voucher");
      console.error(error);
    } finally {
      setLoading(false);
    }
  };
  // API calls end

  return (
    <Box sx={styles.m_cs_cash_sub}>
      <Grid container spacing={1}>
        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
          <Typography
            sx={{
              ...theme.typography.m_sub_title,
              color: theme.palette.text.primary,
            }}
          >
            Gift Vouchers
          </Typography>
        </Grid>
        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
          <TextField
            id="outlined-basic"
            label="Voucher Code"
            variant="outlined"
            fullWidth
            size="small"
            value={voucherCode}
            onChange={handleVoucherCodeChange}
          />
        </Grid>

        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
          <Button
            variant="contained"
            size="medium"
            sx={styles.btn_primary}
            onClick={addVoucherHandler}
            fullWidth
          >
            Add Gift Voucher
          </Button>
        </Grid>
      </Grid>

      <hr sx={{ ...styles.border_bottom }}></hr>

      <Box pt={2}>
        <Stack>
          {vouchers.map((voucher) => (
            <Item key={voucher.code}>
              <Grid
                sx={styles.ks_cash}
                direction={{ xs: "row", sm: "row" }}
                spacing={{ xs: 1, sm: 2, md: 4 }}
              >
                <Item>
                  <Typography
                    sx={{
                      ...theme.typography.caption,
                      color: theme.palette.text.primary,
                      fontWeight: 600,
                    }}
                  >
                    {voucher.vouchercode}
                  </Typography>
                </Item>
                <Item>
                  <Typography
                    sx={{
                      ...theme.typography.caption,
                      color: theme.palette.text.primary,
                      fontWeight: 600,
                    }}
                  >
                    {formatPrice(voucher.voucheramount)}
                  </Typography>
                </Item>

                <IconButton
                  sx={{
                    ...styles.cs_cash_delete_icon,
                  }}
                  onClick={() => removeVoucherHandler(voucher.vouchercode)}
                  aria-label="remove"
                >
                  <DeleteIcon />
                </IconButton>
              </Grid>
            </Item>
          ))}
        </Stack>
      </Box>
      <SnackbarMessage
        open={snackbarOpen}
        handleClose={handleCloseSnackbar}
        message={snackbarMessage}
        severity={snackbarSeverity} // Dynamic severity (success or error)
      />
    </Box>
  );
}
